export default __webpack_public_path__ + "static/media/modal-error-icon.465e520f.svg";